export default {
  dashboard: 'Dashboard',
  liveScreen: 'Live Screen',
  liveScreenOrder: 'Order Tracking',
  performanceInfo: 'Performance Info',
  orderManagement: {
    title: 'Order Management',
    orders: 'Orders',
    ordersPendingAction: 'Orders Pending Action',
    ordersWaitingTransfer: 'Orders Waiting Transfer',
    orderMapAnalysis: 'Order Analysis',
    storeCourierSourceResource: 'Order Courier Management',
  },
  zoneManagement: {
    title: 'Zone and Slot Management',
    zones: 'Zones',
    bulkZoneUpdate: 'Bulk Zone Update',
    templateManagement: 'Template Management',
    templateZoneMatching: 'Template Zone Matching',
    slotMonitoring: 'Slot Monitoring',
    bulkSlotUpdate: 'Bulk Slot Update',
  },
  bonusManagement: {
    title: 'Bonus Management',
    carPool: 'Car Pool',
    bonusDefinitions: 'Bonus Definitions',
    bonusComponents: 'Bonus Components',
    bonusRules: 'Bonus Rules',
    bonusCalculationScreen: 'Bonus Calculation Screen',
    vehicleWorkHours: 'Vehicle Work Hours',
  },
  fleetManagement: {
    title: 'Fleet Management',
    vehicles: 'Vehicles',
    vehicleGroups: 'Vehicle Groups',
    couriers: 'Couriers',
    courierGroups: 'Courier Groups',
    couriersAwaitingApproval: 'Couriers Awaiting Approval',
    courierApplicationList: 'Tradesman Courier Applications',
  },
  routeManagement: {
    title: 'Route Management',
    routePlan: 'Route Plan',
    routeMonitoringList: 'Route Monitoring List',
    routeMonitoring: 'Route Monitoring',
  },
  dynamicCapacityManagement: {
    title: 'Dynamic Capacity Management',
    dynamicCapacity: 'Dynamic Capacity',
  },
  reports: {
    title: 'Reports',
    endOfDayReport: 'End Of Day Report',
  },
  definitions: {
    title: 'Definitions',
    dynamicCapacity: 'Dinamik Kapasite',
    citiesServed: 'Cities Served',
    distributionCenters: 'Distribution Centers',
    zones: 'Zones',
    routingParameterProfiles: 'Routing Parameter Profiles',
    routingParameters: 'Routing Parameters',
    penalty: 'Routing Penalties',
    users: 'Users',
    publicHolidays: 'Public Holidays',
    firms: 'Firms',
    bulkDefinitionTracing: 'Bulk Definition Tracing',
    massNotification: 'Mass Notification Creation',
  },
  storeManagement: {
    title: 'Store Management',
    stores: 'Stores',
    storeBasedSectionSort: 'Store Based Section Sort',
    storeGroups: 'Branches',
    waitingApproveStores: 'Waiting Approve Stores',
  },
  productManagement: {
    title: 'Product Management',
    orderItemProperties: 'Order Item Properties',
    partialDeliveryApproval:
      'Partial Delivery Approval',
    cancelledItemHistory: "Cancelled Item History"
  },
  parameters: {
    title: 'Parameters',
    parameterSettings: 'Settings',
  },
  routingManagement: {
    title: 'Routing Management',
    routingViewList: 'Routing View List',
    routingDetail: 'Routing Detail',
    routingPlanning: 'Routing Planning',
  },
  progressPaymentSystem: {
    title: 'Progress Payment System',
    progressPaymentTemplates: 'Progress Payment Templates',
    progressPaymentStatusTracking: 'Progress Payment Status Tracking',
    progressPaymentTemplateByStore: 'Store Matches',
  },
  storeTask: {
    title: 'Store Schedule',
    storeTaskTemplate: 'Schedule Templates',
  },
  stockManagement: {
    title: 'Stock Management',
    stockTrackingScreen: 'Stocks',
    stockTransactions: 'Stock Transactions',
  },
  settings: {
    title: 'Settings',
    myProfile: 'My Profile',
  },
};
